import { render } from "./ModalBtn.vue?vue&type=template&id=57135796"
import script from "./ModalBtn.vue?vue&type=script&lang=js"
export * from "./ModalBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/modal/ModalBtn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57135796"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57135796', __exports__)) {
    api.reload('57135796', __exports__)
  }
  
  module.hot.accept("./ModalBtn.vue?vue&type=template&id=57135796", () => {
    api.rerender('57135796', render)
  })

}


export default __exports__